import { ListItemButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekListItemButton = styled(ListItemButton)(({ theme }) => ({}));

export { PeekListItemButton, PeekListItemButton as default };
